import { Component } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'chromebook-selector';
  environmentName: string = '';

  constructor(
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry
  ){
    this.matIconRegistry.addSvgIcon(
      'icon_kiosk', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-use-case-kiosk.svg')
    );
  }
}
